<div class="header">
  <h2>Lektionen</h2>
</div>

<div class="lessons">
  @for(l of lessons; track l.id) {
  <div class="item" (click)="openLesson(l.id)">
    <span class="title">
      {{ l.title }}
    </span>
    <span class="info">
      {{ l.updatedAt | date : "short" : "CET" }}
    </span>
    <span class="info"> {{ l.items.length }} Items </span>

    <button nbButton status="primary">
      <nb-icon icon="edit-2-outline"></nb-icon>
    </button>
  </div>
  }
</div>
